module.exports = __webpack_public_path__ + "images/emoji/crystal_ball.6a4aa42794378837d116.png";